import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { NoAccess } from './NoAccess';
// import { RequestAccess } from './RequestAccess';

export const RoutesWithoutAccess = () => {
  // console.log('rendering routes without');
  return (
    <Switch>
      <Route path="/" exact>
        <NoAccess />
      </Route>
      {/* <Route path="/request-access">
        <RequestAccess />
      </Route> */}
    </Switch>
  );
};
